import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Page, PageEmptyState, PageErrorState, Typography } from 'seagull';
import { CreateProposalButton } from '~/components/CreateProposalButton/CreateProposalButton';
import SeeWhatItsLike from '~/components/SeeWhatItsLike/SeeWhatItsLike';
import EmptyStateIllustartion from './InvoiceDashboardEmptyStateIllustration.svg';
import img1 from './SeeWhatItsLikeImages/1.png';
import img2 from './SeeWhatItsLikeImages/2.png';
export const NoInvoices = (param)=>{
    let { title, isVendor } = param;
    return /*#__PURE__*/ _jsx(Page, {
        header: title,
        variant: "containedHeight",
        children: /*#__PURE__*/ _jsx(PageEmptyState, {
            maxHeight: true,
            testId: "invoices-empty",
            illustration: /*#__PURE__*/ _jsx(EmptyStateIllustartion, {}),
            title: "Automatic invoicing is the new standard",
            message: "Invoices are generated automatically according to the agreement’s commercial terms, and your T&Cs.",
            actions: isVendor && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SeeWhatItsLike, {
                        steps: [
                            {
                                title: 'We issue your invoice and make sure it gets paid!',
                                subtitle: 'Invoices are accessible to you and your client at all times. If action is required by your client, we make sure to remind them, saving you the hassle of being the middleman.',
                                image: {
                                    src: img1,
                                    width: 1246,
                                    height: 737
                                }
                            },
                            {
                                title: 'Getting paid is finally seamless',
                                subtitle: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            skin: "invertedStandard",
                                            children: "Invoices are automatically issued and updated with the appropriate status in one convenient place."
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            skin: "invertedStandard",
                                            children: "\uD83D\uDCA1 According to our data, 93.8% of invoices issued on Anchor are paid on the same day!"
                                        })
                                    ]
                                }),
                                image: {
                                    src: img2,
                                    width: 1246,
                                    height: 737
                                }
                            }
                        ],
                        testId: "invoices-dashboard"
                    }, "see-what-its-like"),
                    /*#__PURE__*/ _jsx(CreateProposalButton, {
                        hidePrefix: true
                    }, "create-proposal-button")
                ]
            })
        })
    });
};
export const NoFilteredInvoices = (param)=>{
    let { resetFilters } = param;
    return /*#__PURE__*/ _jsx(PageEmptyState, {
        illustration: /*#__PURE__*/ _jsx(EmptyStateIllustartion, {}),
        title: "No invoices match your request",
        message: "Try adjusting your search by removing filters.",
        actions: /*#__PURE__*/ _jsx(Button, {
            onClick: resetFilters,
            children: "Remove all filters"
        })
    });
};
export const ErrorPage = (param)=>{
    let { retry, title } = param;
    return /*#__PURE__*/ _jsx(PageErrorState, {
        testId: "error-state-page",
        title: title,
        onRefresh: retry
    });
};
